import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@sg/garnish';

import {
  AccountScreenContainer,
  AccountScreenSection,
  AccountScreenTitle,
} from '@order/components';

// ─────────────────────────────────────────────────────────────────────

export const NotificationPreferencesContainer = (props: Props) => {
  const { children, title } = props;

  return (
    <AccountScreenContainer screen="notifications">
      <AccountScreenTitle title={title} />
      <AccountScreenSection>
        <View style={styles.container}>{children}</View>
      </AccountScreenSection>
    </AccountScreenContainer>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing[4],
  },
});

// ─── Types ───────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  title: string;
}>;
